import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { geoFromHeaders, type VisitorGeo } from "./visitor-geo";

export const getVisitorGeoFn = createServerFn({ method: "GET" }).handler(
  async (): Promise<VisitorGeo> => geoFromHeaders((n) => getRequestHeader(n)),
);
